import APIURLMaker from "../../../utils/APIURLMaker";
import { getAuthorizationHeaders } from "../../../services/authToken";

const ACCESS_STATES = {
  RECORD_NOT_FOUND: "RECORD_NOT_FOUND",
  RESTRICTED: "RESTRICTED",
  PUBLIC_VIEW: "PUBLIC_VIEW",
  PUBLIC_EDIT: "PUBLIC_EDIT",
};

const RECORD_TYPES = {
  PROJECT: "PROJECT",
  COLLECTION: "COLLECTION",
  ENTITY: "ENTITY",
  UNKNOWN: "UNKNOWN",
};

export { ACCESS_STATES, RECORD_TYPES };

/** Dedupes StrictMode remounts + page+loader double fetches for the same share id. */
const RESOLVE_CACHE_TTL_MS = 8000;
const resolveCache = new Map();

/**
 * Guest/public share resolve.
 * Only GET /api/record/{recordId}. Child collections/entities come from record.children.
 * Do not call /record/{id}/collections or /record/{id}/entities from the FE.
 */
export async function resolveSharedRecord(recordId) {
  if (!recordId) {
    return { ok: false, status: 0, data: null };
  }

  const cached = resolveCache.get(recordId);
  if (cached?.promise) {
    return cached.promise;
  }
  if (cached?.result && cached.expiresAt > Date.now()) {
    return cached.result;
  }

  const promise = (async () => {
    const url = APIURLMaker(`record/${recordId}`);
    const headers = getAuthorizationHeaders();

    const response = await fetch(url, {
      method: "GET",
      headers,
    });

    let payload = null;
    try {
      payload = await response.json();
    } catch (error) {
      payload = null;
    }

    const result = {
      ok: response.ok,
      status: response.status,
      data: payload,
    };

    resolveCache.set(recordId, {
      result,
      expiresAt: Date.now() + RESOLVE_CACHE_TTL_MS,
    });

    return result;
  })();

  resolveCache.set(recordId, { promise, expiresAt: 0 });

  try {
    return await promise;
  } catch (error) {
    resolveCache.delete(recordId);
    throw error;
  }
}
